import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

interface GlideOptions {
  selector?: string | string[]
  once?: boolean
  y?: number
  duration?: number
  ease?: string
  container?: HTMLElement | Document
}

export function initGlideUp({
  selector = '[glide]',
  once = true,
  y = 48,
  duration = 1.2,
  ease = 'power2.out',
  container = document
}: GlideOptions = {}) {
  const selectors = Array.isArray(selector) ? selector : [selector]
  const glideElements = selectors.flatMap((sel) =>
    Array.from(container.querySelectorAll<HTMLElement>(sel))
  )

  const wysiwygElements = Array.from(
    container.querySelectorAll<HTMLElement>('.wysiwyg p, .wysiwyg ul, .wysiwyg ol, .wysiwyg img')
  )
  const nodes = [...glideElements, ...wysiwygElements].filter((el) => el.dataset.animDone !== '1')

  if (!nodes.length) {
    return
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    nodes.forEach((el) => {
      el.dataset.animDone = '1'
    })
    return
  }

  gsap.set(nodes, { opacity: 0, y })

  nodes.forEach((el: HTMLElement) => {
    const animate = () => {
      gsap.set(el, { willChange: 'transform, opacity' })

      gsap.to(el, {
        opacity: 1,
        y: 0,
        ease,
        duration,
        immediateRender: false,
        force3D: false,
        onComplete() {
          gsap.set(el, { clearProps: 'willChange' })
          el.dataset.animDone = '1'
        }
      })
    }

    ScrollTrigger.create({
      trigger: el,
      start: 'top 90%',
      once,
      onEnter: animate,
      onEnterBack: !once ? animate : undefined,
      invalidateOnRefresh: false
    })
  })

  requestAnimationFrame(() => {
    ScrollTrigger.refresh()
  })
}
